export default __webpack_public_path__ + "static/media/3-min.21c7ae78.jpg";